import { RequestDetail } from '../../core/models/request-detail.model';
import { RequestStatus } from '../../core/enums/request-status.enum';
import { PrintSite } from '../../core/enums/print-site.enum';
import { PrintLocation } from '../../core/enums/print-location.enum';

export const MOCK_REQUEST_DETAILS: Record<number, RequestDetail> = {
  12345: {
    requestNumber: 12345,
    companyName: 'Acme Corporation',
    contactName: 'John Smith',
    expeditedRequest: true,
    waiveExpeditedFee: false,
    specialHandling: true,
    arNumber: 'AR-2026-001234',
    createdBy: 'jane.doe@company.com',
    country: 'United States',
    phoneNumber: 5551234567,
    requestStatus: RequestStatus.Open,
    requestStatusId: 1,
    emailAddresses: 'john.smith@acme.com, billing@acme.com',
    assignedTo: 'operator1@fps.com',
    assignedUserId: 189,
    printSite: PrintSite.Weston,
    printSiteId: 1,
    printLocation: PrintLocation.APP1,
    printLocationId: 1,
    printLocationName: 'Weston APP 1',
    printerType: 'HP',
    sortOrder: 'Backwards',
    printPostage: true,
    comments: '',
    commentsHistory:
      '3/12/2026 8:23:22 AM: Request details updated by AlexM\n\n' +
      '3/12/2026 8:27:03 AM: Request submitted for printing at print site Weston by AlexM. - Request Updated by CheckLogs Application\n\n' +
      '3/24/2026 2:48:22 PM: Request details updated. Print Site updated to Weston. by AayushR',
    fileDetails: [
      {
        id: 5570,
        fileName: 'payroll_checks_batch1.pdf',
        status: RequestStatus.Open,
        fileStatusName: 'Open',
        checkCount: 150,
        ddaCount: 3,
        docsInFile: 150,
        totalAmountOfDocs: 45750.0,
        fileNumber: '12345.01',
        readyToProcess: true,
      },
      {
        id: 5571,
        fileName: 'payroll_checks_batch2.pdf',
        status: RequestStatus.Open,
        fileStatusName: 'Open',
        checkCount: 200,
        ddaCount: 5,
        docsInFile: 200,
        totalAmountOfDocs: 62500.0,
        fileNumber: '12345.02',
        readyToProcess: true,
      },
      {
        id: 5572,
        fileName: 'bonus_payments.pdf',
        status: RequestStatus.Received,
        fileStatusName: 'Received',
        checkCount: 50,
        ddaCount: 1,
        docsInFile: 50,
        totalAmountOfDocs: 125000.0,
        fileNumber: '12345.03',
        readyToProcess: false,
      },
    ],
  },
  12346: {
    requestNumber: 12346,
    companyName: 'Beta Industries',
    contactName: 'Sarah Johnson',
    expeditedRequest: false,
    waiveExpeditedFee: false,
    specialHandling: false,
    arNumber: 'AR-2026-001235',
    createdBy: 'admin@beta.com',
    country: 'Canada',
    phoneNumber: 4161234567,
    requestStatus: RequestStatus.Sent,
    requestStatusId: 6,
    emailAddresses: 'sarah.johnson@beta.com',
    assignedTo: 'operator2@fps.com',
    assignedUserId: 13,
    printSite: PrintSite.Memphis,
    printSiteId: 2,
    printLocation: PrintLocation.APP2,
    printLocationId: 2,
    printLocationName: 'Memphis APP 2',
    printerType: 'Xerox',
    sortOrder: 'Forwards',
    printPostage: false,
    comments: '',
    commentsHistory:
      '2/18/2026 11:00:00 AM: Request created and sent for processing by admin@beta.com',
    fileDetails: [
      {
        id: 5573,
        fileName: 'quarterly_statements.pdf',
        status: RequestStatus.Sent,
        fileStatusName: 'Sent',
        checkCount: 500,
        ddaCount: 10,
        docsInFile: 500,
        totalAmountOfDocs: 250000.0,
        fileNumber: '12346.01',
        readyToProcess: true,
      },
    ],
  },
};

export function getMockRequestDetail(
  requestNumber: number
): RequestDetail | null {
  return MOCK_REQUEST_DETAILS[requestNumber] || null;
}
